module.exports = __webpack_public_path__ + "static/logo02-9d60eb49abede57fb71ff04ddf666915.png";